import React, { useEffect, useMemo, useState } from "react";
import { useOverlay } from "./InteractionPreviewHook";
import "./TrainingPreviewOverlay.css";
import { useSelector } from "react-redux";
import { SelectedTab, selectSelectedTab } from "../../app/slices/GlobalSlice";
import classNames from "classnames";
import {
  selectTrainingType,
  TrainingType,
} from "../../app/slices/TrainingSlice";
import { WebSocketService } from "../../services/WebSocketService";
import {
  CreatorNetworkMessage,
  CreatorNetworkMessageType,
} from "../../models/CreatorNetworkMessage";
import { useMediaQuery } from "@mui/material";
export default function TrainingPreviewOverlay() {
  const { getOverlayElement } = useOverlay();
  const selectedTab = useSelector(selectSelectedTab);
  const trainingType = useSelector(selectTrainingType);

  const preview = useMemo(() => {
    return getOverlayElement();
  }, [getOverlayElement]);

  return (
    <div className="pointer-events-none trainingbubblepreviewoverlay-root">
      <div
        className={classNames("pointer-events-auto", {
          "h-full": trainingType === TrainingType.Training360,
        })}
      >
        {selectedTab === SelectedTab.Timeline && preview}
      </div>
    </div>
  );
}
